import React from "react"
import { RegisterOptions, useFormContext } from "react-hook-form"
import { getErrorMessage } from "./Errors"

import * as styles from "./RHFTextField.module.css"

export const RHFTextField = ({
  name,
  label,
  className,
  validation,
  type = "email",
}: {
  name: string
  label: string
  className?: string
  validation?: RegisterOptions
  type?: "email" | "text"
}) => {
  const {
    register,
    formState: { errors, isDirty, isSubmitted },
  } = useFormContext()
  return (
    <div className={className}>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
          {validation?.required && "*"}
        </label>
      )}
      <input
        id={name}
        className={styles.input}
        type={type}
        {...register(name, validation)}
      />

      {(isDirty || isSubmitted) && (
        <span className={styles.error}>
          {getErrorMessage(label, errors[name])}
        </span>
      )}
    </div>
  )
}
